import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetAuthState, setAuthData } from './authReducer';
import { Organisation, Plan, User } from '../types';

interface OrganizationState {
  organisation: Organisation | null;
  users: User[] | null;
  plans: Plan[] | null;
  loading: boolean;
  error: any;
}

const initialState: OrganizationState = {
  organisation: null,
  users: null,
  plans: null,
  loading: false,
  error: null,
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    fetchUsersStart(state) {
      state.loading = true;
      state.error = null;
    },
    setUsersData(state, action: PayloadAction<User[]>) {
      setAuthData();
      state.users = action.payload;
      state.loading = false;
    },
    fetchUsersError(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
      resetAuthState();
    },
    fetchPlansStart(state) {
      state.loading = true;
      state.error = null;
    },
    setPlansData(state, action: PayloadAction<Plan[]>) {
      state.plans = action.payload;
      state.loading = false;
      setAuthData();
    },
    fetchPlansError(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
      resetAuthState();
    },
    fetchOrganisationStart(state) {
      state.loading = true;
      state.error = null;
    },
    setOrganisationData(state, action: PayloadAction<Organisation>) {
      state.organisation = action.payload;
      state.loading = false;
      setAuthData();
    },
    fetchOrganisationError(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
      resetAuthState();
    },
    resetOrganisationState: () => initialState,
  },
});

export const {
  fetchUsersStart,
  setUsersData,
  fetchUsersError,
  fetchPlansStart,
  setPlansData,
  fetchPlansError,
  setOrganisationData,
  fetchOrganisationError,
  fetchOrganisationStart,
  resetOrganisationState,
} = organizationSlice.actions;

export default organizationSlice.reducer;
